<route>
{
  "meta": {
    "permission": [
      "packages.view_package"
    ]
  }
}
</route>

<template>
  <v-container fluid style="min-height: 1000px">
    <!-- Nuevo paquete -->
    <v-tooltip v-if="isAdmin" top left>
      <template v-slot:activator="{ on }">
        <v-btn
          bottom
          color="secondary"
          dark
          fab
          fixed
          right
          @click="changeRoute({ pk: 'create' })"
          v-on="on"
        >
          <v-icon>fa-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('new_package') }}</span>
    </v-tooltip>

    <!-- Lista de paquetes -->
    <v-row class="my-0">
      <v-col
        v-for="item in package_list"
        :key="item.pk"
        class="text-center p-3"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card elevation="2">
          <i-toolbar dontSave :title="item.name" :loading="load"></i-toolbar>
          <v-card-text v-if="!isLat">
            <div v-if="item.cost_prom === '0.00'">
              <div class="package-index-price">
                <h3>${{ item.cost }}</h3>
                <h3 class="currency">USD</h3>
              </div>
              <div v-if="item.cost !== '0.00'" class="package-index-pay-button">
                <!-- Botón amarillo paypal -->
                <PayPal
                  currency="USD"
                  env="sandbox"
                  :id="'item.id'"
                  :amount="item.cost"
                  :button-style="styleButtonPaypalGold"
                  :customer="credentials"
                  @payment-cancelled="PayCancelled"
                  @payment-completed="PayCompleted($event, item.id)"
                ></PayPal>
              </div>
              <div v-else class="package-index-pay-button">
                <v-btn
                  class="package-index-btn"
                  small
                  dark
                  color="indigo lighten-1"
                  @click="FreePay(item.id)"
                >
                  <img
                    class="paypal-button-logo paypal-button-logo-pp paypal-button-logo-gold"
                    src="data:image/svg+xml;base64,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"
                    alt="pp"
                    style="visibility: visible"
                  />
                  <img
                    class="paypal-button-logo paypal-button-logo-paypal paypal-button-logo-gold"
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMTAwIDMyIiB4bWxucz0iaHR0cDomI3gyRjsmI3gyRjt3d3cudzMub3JnJiN4MkY7MjAwMCYjeDJGO3N2ZyIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pbllNaW4gbWVldCI+PHBhdGggZmlsbD0iIzAwMzA4NyIgZD0iTSAxMiA0LjkxNyBMIDQuMiA0LjkxNyBDIDMuNyA0LjkxNyAzLjIgNS4zMTcgMy4xIDUuODE3IEwgMCAyNS44MTcgQyAtMC4xIDI2LjIxNyAwLjIgMjYuNTE3IDAuNiAyNi41MTcgTCA0LjMgMjYuNTE3IEMgNC44IDI2LjUxNyA1LjMgMjYuMTE3IDUuNCAyNS42MTcgTCA2LjIgMjAuMjE3IEMgNi4zIDE5LjcxNyA2LjcgMTkuMzE3IDcuMyAxOS4zMTcgTCA5LjggMTkuMzE3IEMgMTQuOSAxOS4zMTcgMTcuOSAxNi44MTcgMTguNyAxMS45MTcgQyAxOSA5LjgxNyAxOC43IDguMTE3IDE3LjcgNi45MTcgQyAxNi42IDUuNjE3IDE0LjYgNC45MTcgMTIgNC45MTcgWiBNIDEyLjkgMTIuMjE3IEMgMTIuNSAxNS4wMTcgMTAuMyAxNS4wMTcgOC4zIDE1LjAxNyBMIDcuMSAxNS4wMTcgTCA3LjkgOS44MTcgQyA3LjkgOS41MTcgOC4yIDkuMzE3IDguNSA5LjMxNyBMIDkgOS4zMTcgQyAxMC40IDkuMzE3IDExLjcgOS4zMTcgMTIuNCAxMC4xMTcgQyAxMi45IDEwLjUxNyAxMy4xIDExLjIxNyAxMi45IDEyLjIxNyBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwMzA4NyIgZD0iTSAzNS4yIDEyLjExNyBMIDMxLjUgMTIuMTE3IEMgMzEuMiAxMi4xMTcgMzAuOSAxMi4zMTcgMzAuOSAxMi42MTcgTCAzMC43IDEzLjYxNyBMIDMwLjQgMTMuMjE3IEMgMjkuNiAxMi4wMTcgMjcuOCAxMS42MTcgMjYgMTEuNjE3IEMgMjEuOSAxMS42MTcgMTguNCAxNC43MTcgMTcuNyAxOS4xMTcgQyAxNy4zIDIxLjMxNyAxNy44IDIzLjQxNyAxOS4xIDI0LjgxNyBDIDIwLjIgMjYuMTE3IDIxLjkgMjYuNzE3IDIzLjggMjYuNzE3IEMgMjcuMSAyNi43MTcgMjkgMjQuNjE3IDI5IDI0LjYxNyBMIDI4LjggMjUuNjE3IEMgMjguNyAyNi4wMTcgMjkgMjYuNDE3IDI5LjQgMjYuNDE3IEwgMzIuOCAyNi40MTcgQyAzMy4zIDI2LjQxNyAzMy44IDI2LjAxNyAzMy45IDI1LjUxNyBMIDM1LjkgMTIuNzE3IEMgMzYgMTIuNTE3IDM1LjYgMTIuMTE3IDM1LjIgMTIuMTE3IFogTSAzMC4xIDE5LjMxNyBDIDI5LjcgMjEuNDE3IDI4LjEgMjIuOTE3IDI1LjkgMjIuOTE3IEMgMjQuOCAyMi45MTcgMjQgMjIuNjE3IDIzLjQgMjEuOTE3IEMgMjIuOCAyMS4yMTcgMjIuNiAyMC4zMTcgMjIuOCAxOS4zMTcgQyAyMy4xIDE3LjIxNyAyNC45IDE1LjcxNyAyNyAxNS43MTcgQyAyOC4xIDE1LjcxNyAyOC45IDE2LjExNyAyOS41IDE2LjcxNyBDIDMwIDE3LjQxNyAzMC4yIDE4LjMxNyAzMC4xIDE5LjMxNyBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwMzA4NyIgZD0iTSA1NS4xIDEyLjExNyBMIDUxLjQgMTIuMTE3IEMgNTEgMTIuMTE3IDUwLjcgMTIuMzE3IDUwLjUgMTIuNjE3IEwgNDUuMyAyMC4yMTcgTCA0My4xIDEyLjkxNyBDIDQzIDEyLjQxNyA0Mi41IDEyLjExNyA0Mi4xIDEyLjExNyBMIDM4LjQgMTIuMTE3IEMgMzggMTIuMTE3IDM3LjYgMTIuNTE3IDM3LjggMTMuMDE3IEwgNDEuOSAyNS4xMTcgTCAzOCAzMC41MTcgQyAzNy43IDMwLjkxNyAzOCAzMS41MTcgMzguNSAzMS41MTcgTCA0Mi4yIDMxLjUxNyBDIDQyLjYgMzEuNTE3IDQyLjkgMzEuMzE3IDQzLjEgMzEuMDE3IEwgNTUuNiAxMy4wMTcgQyA1NS45IDEyLjcxNyA1NS42IDEyLjExNyA1NS4xIDEyLjExNyBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwOWNkZSIgZD0iTSA2Ny41IDQuOTE3IEwgNTkuNyA0LjkxNyBDIDU5LjIgNC45MTcgNTguNyA1LjMxNyA1OC42IDUuODE3IEwgNTUuNSAyNS43MTcgQyA1NS40IDI2LjExNyA1NS43IDI2LjQxNyA1Ni4xIDI2LjQxNyBMIDYwLjEgMjYuNDE3IEMgNjAuNSAyNi40MTcgNjAuOCAyNi4xMTcgNjAuOCAyNS44MTcgTCA2MS43IDIwLjExNyBDIDYxLjggMTkuNjE3IDYyLjIgMTkuMjE3IDYyLjggMTkuMjE3IEwgNjUuMyAxOS4yMTcgQyA3MC40IDE5LjIxNyA3My40IDE2LjcxNyA3NC4yIDExLjgxNyBDIDc0LjUgOS43MTcgNzQuMiA4LjAxNyA3My4yIDYuODE3IEMgNzIgNS42MTcgNzAuMSA0LjkxNyA2Ny41IDQuOTE3IFogTSA2OC40IDEyLjIxNyBDIDY4IDE1LjAxNyA2NS44IDE1LjAxNyA2My44IDE1LjAxNyBMIDYyLjYgMTUuMDE3IEwgNjMuNCA5LjgxNyBDIDYzLjQgOS41MTcgNjMuNyA5LjMxNyA2NCA5LjMxNyBMIDY0LjUgOS4zMTcgQyA2NS45IDkuMzE3IDY3LjIgOS4zMTcgNjcuOSAxMC4xMTcgQyA2OC40IDEwLjUxNyA2OC41IDExLjIxNyA2OC40IDEyLjIxNyBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwOWNkZSIgZD0iTSA5MC43IDEyLjExNyBMIDg3IDEyLjExNyBDIDg2LjcgMTIuMTE3IDg2LjQgMTIuMzE3IDg2LjQgMTIuNjE3IEwgODYuMiAxMy42MTcgTCA4NS45IDEzLjIxNyBDIDg1LjEgMTIuMDE3IDgzLjMgMTEuNjE3IDgxLjUgMTEuNjE3IEMgNzcuNCAxMS42MTcgNzMuOSAxNC43MTcgNzMuMiAxOS4xMTcgQyA3Mi44IDIxLjMxNyA3My4zIDIzLjQxNyA3NC42IDI0LjgxNyBDIDc1LjcgMjYuMTE3IDc3LjQgMjYuNzE3IDc5LjMgMjYuNzE3IEMgODIuNiAyNi43MTcgODQuNSAyNC42MTcgODQuNSAyNC42MTcgTCA4NC4zIDI1LjYxNyBDIDg0LjIgMjYuMDE3IDg0LjUgMjYuNDE3IDg0LjkgMjYuNDE3IEwgODguMyAyNi40MTcgQyA4OC44IDI2LjQxNyA4OS4zIDI2LjAxNyA4OS40IDI1LjUxNyBMIDkxLjQgMTIuNzE3IEMgOTEuNCAxMi41MTcgOTEuMSAxMi4xMTcgOTAuNyAxMi4xMTcgWiBNIDg1LjUgMTkuMzE3IEMgODUuMSAyMS40MTcgODMuNSAyMi45MTcgODEuMyAyMi45MTcgQyA4MC4yIDIyLjkxNyA3OS40IDIyLjYxNyA3OC44IDIxLjkxNyBDIDc4LjIgMjEuMjE3IDc4IDIwLjMxNyA3OC4yIDE5LjMxNyBDIDc4LjUgMTcuMjE3IDgwLjMgMTUuNzE3IDgyLjQgMTUuNzE3IEMgODMuNSAxNS43MTcgODQuMyAxNi4xMTcgODQuOSAxNi43MTcgQyA4NS41IDE3LjQxNyA4NS43IDE4LjMxNyA4NS41IDE5LjMxNyBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwOWNkZSIgZD0iTSA5NS4xIDUuNDE3IEwgOTEuOSAyNS43MTcgQyA5MS44IDI2LjExNyA5Mi4xIDI2LjQxNyA5Mi41IDI2LjQxNyBMIDk1LjcgMjYuNDE3IEMgOTYuMiAyNi40MTcgOTYuNyAyNi4wMTcgOTYuOCAyNS41MTcgTCAxMDAgNS42MTcgQyAxMDAuMSA1LjIxNyA5OS44IDQuOTE3IDk5LjQgNC45MTcgTCA5NS44IDQuOTE3IEMgOTUuNCA0LjkxNyA5NS4yIDUuMTE3IDk1LjEgNS40MTcgWiI+PC9wYXRoPjwvc3ZnPg=="
                    alt="paypal"
                    style="visibility: visible"
                  />
                </v-btn>
                <div class="package-pay-button-tagline">
                  La forma rápida y segura de pagar
                </div>
              </div>
            </div>
            <div v-else>
              <div class="package-index-price">
                <h3 class="promo">USD ${{ item.cost }}</h3>
                <h3>${{ item.cost_prom }}</h3>
                <h3 class="currency">USD</h3>
              </div>
              <div class="package-index-pay-button">
                <PayPal
                  currency="USD"
                  env="sandbox"
                  :button-style="styleButtonPaypalGold"
                  :amount="item.cost_prom"
                  :customer="credentials"
                  @payment-cancelled="PayCancelled"
                  @payment-completed="PayCompleted($event, item.id)"
                ></PayPal>
              </div>
            </div>
            <h5>{{ item.days }} {{ $t('days') }} {{ $t('available') }}</h5>
            <template v-if="isAdmin">
              <i-btn
                :title="$t('edit')"
                outlined
                classes="p-3 mx-1 mb-3"
                small
                color="info"
                icon="mdi-pencil"
                @click="changeRoute({ pk: item.id })"
              />
              <i-btn
                :title="$tc('delete', 1)"
                classes="p-3 mx-1 mb-3"
                outlined
                small
                color="error"
                icon="fa-trash"
                @click="showDelete(item.id)"
              />
            </template>
            <span v-if="item.description">
              <v-list dense class="py-0">
                <v-list-group>
                  <v-icon slot="appendIcon" size="12">fas fa-arrow-down</v-icon>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="caption font-weight-normal">{{
                          $t('more_info')
                        }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-title
                        class="pl-4"
                        style="font-size: 13px; font-weight: 400"
                      >
                        <span v-html="item.description"></span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </span>
          </v-card-text>
          <v-card-text v-else>
            <span v-if="item.cost_lat_prom === '0.00'">
              <h3>USD ${{ item.cost_lat }}</h3>
            </span>
            <span v-else>
              <h3>
                <del>USD ${{ item.cost_lat }}</del>
              </h3>
              <h3>USD ${{ item.cost_lat_prom }}</h3>
            </span>
            <h5>{{ item.days }} {{ $t('days') }} {{ $t('available') }}</h5>
            <span v-if="item.description_lat">
              <v-list dense class="py-0">
                <v-list-group>
                  <v-icon slot="appendIcon" size="12">fas fa-arrow-down</v-icon>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="caption font-weight-normal">
                          {{ $t('more_info') }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-title
                        class="pl-4"
                        style="font-size: 13px; font-weight: 400"
                      >
                        <span v-html="item.description_lat"></span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </span>
          </v-card-text>
          <template v-slot:item.description="{ item }">
            <span v-if="item.description" v-html="item.description"></span>
            <span
              v-if="item.description_lat"
              v-html="item.description_lat"
            ></span>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal -->
    <v-dialog max-width="800">
      <v-card>
        <v-flex xs12 justify-center>
          <v-card-title class="headline primary white--text" primary-title>
            <span class="headline">
              {{ $tc('delete', 1) }} {{ $t('package') }}
            </span>
          </v-card-title>
        </v-flex>
        <v-card-text>
          <h3>{{ $t('delete_record_question') }}</h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="remove">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PayPal from 'vue-paypal-checkout'

export default {
  components: {
    PayPal
  },
  data() {
    return {
      package_list: [],
      load: false,
      loading: false,
      isLat: false,
      buy_subdomain: false,
      current_plan: 0,
      credentials: {
        sandbox:
          'AfGoC78cmMH3kwi123MDEi-O9S6ZBCMZfbRmkOlU-Xgln5n23g57vFMl4QRpfn4H_byibxkuko4lyBW1',
        production:
          'AfGoC78cmMH3kwi123MDEi-O9S6ZBCMZfbRmkOlU-Xgln5n23g57vFMl4QRpfn4H_byibxkuko4lyBW1'
      },
      styleButtonPaypalGold: {
        label: 'checkout',
        size: 'responsive', // small | medium | large | responsive
        shape: 'rect', // pill | rect
        color: 'gold' // gold | blue | silver | black
      }
    }
  },
  created() {
    this.unwatch = this.$store.watch(
      () => this.$store.getters['confirmation/getConfirmationFinished'],
      async (val) => {
        if (val === this.title) {
          this.delete_modal = false
          this.loadPackages()
          this.$emit('updateDesigners')
          this.$store.dispatch('confirmation/confirmationFinished', false)
        }
      }
    )
  },
  beforeDestroy() {
    this.unwatch()
  },
  computed: {
    ...mapGetters({
      me: 'session/me',
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    packageBtn() {
      return {
        add: this.getPermissions([`packages.add_package`]),
        delete: this.getPermissions([`packages.delete_package`]),
        edit: this.getPermissions([`packages.change_package`]),
        view: this.getPermissions([`packages.view_package`])
      }
    }
  },
  methods: {
    ...mapActions({
      showConfirmation: 'confirmation/confirmationValue'
    }),
    changeRoute(item, id) {
      this.$router.push({
        name: 'package-pk',
        params: { pk: this.codification({ code: item.pk }) }
      })
    },
    loadPackages() {
      this.$api.company.packages
        .list({})
        .then((response) => {
          this.package_list = response.data.results
        })
        .finally(() => {
          if (this.$store.getters.getIsloading) {
            this.$store.dispatch('actionLoading')
          }
          this.loading = false
        })
    },
    showDelete(id) {
      this.delete_id = id
      this.remove(id)
    },
    remove(id) {
      this.showConfirmation({
        show: true,
        model: this.title,
        title: this.$tc('delete', 1),
        type: 'error white--text',
        content: this.$t('confirm_delete'),
        alert: `${this.$t('success', {
          model: this.title,
          action: this.$tc('delete', 2)
        })}`,
        confirm: () => this.$api.company.packages.remove({ pk: id })
      })
    },
    PayCompleted(data, plan_id) {
      let payment = {
        state: data.state,
        user_id: this.me.id,
        amount: data.transactions[0].amount.total,
        date_pay: data.create_time,
        payment_type: data.payer.payment_method,
        payment_number: data.id,
        package_id: plan_id
      }
      this.sendPackage(payment)
      this.buy_subdomain = true
    },
    PayCancelled(data) {
      //
    },
    FreePay(plan_id) {
      let data = {
        state: 'approved',
        user_id: this.me.id,
        date_pay: new Date(),
        payment_type: 'paypal',
        package_id: plan_id
      }
      this.sendPackage(data)
      this.$router.push({
        name: 'company-pk',
        params: { pk: this.codification({ code: 'create' }) }
      })
    },
    sendPackage(data) {
      this.$api.company.payment
        .create({
          form: data
        })
        .then((response) => {
          this.current_plan = response.data.id
          this.createdSubdomain()
        })
        .catch((error) => {
          console.error(error.response)
        })
    },
    createdSubdomain() {
      this.buy_subdomain = true
      this.$router.push({
        name: 'company-pk',
        params: { pk: this.codification({ code: 'create' }) }
      })
    }
  },
  mounted() {
    this.loadPackages()
  }
}
</script>
<style lang="sass">
.zoid-outlet
  z-index: 1
.package-index-price
  text-align: center
  padding-left: 0
  padding-right: 0
  padding-bottom: 16px
  min-height: 120px
  display: flex
  flex-direction: column
  justify-content: center
  h3
    margin: 0
    &.promo
      font-size: small
      text-decoration: line-through
    &.currency
      color: var(--v-muted-base)

.package-index-pay-button
  min-height: 70px
  &-tagline
    color: var(--v-muted-base)
    font-size: 11px
    font-weight: 400
    line-height: 180x

.package-index-btn
  width: 100%
  min-height: 44px
  @media (width > 1264px)
    min-height: 35px
</style>
